import { render, staticRenderFns } from "./UserElement.vue?vue&type=template&id=cb608402"
import script from "./UserElement.vue?vue&type=script&lang=js"
export * from "./UserElement.vue?vue&type=script&lang=js"
import style0 from "./UserElement.vue?vue&type=style&index=0&id=cb608402&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports